import React from 'react';
import { NavigationItem } from '@client/components/navigation/NavigationItem';

const unauthenticatedRoutes = [
  {
    name: 'Hitta insamlingar',
    path: '/insamlingar/',
  },
  {
    name: 'Frågor och svar',
    path: '/hjalp/',
  },
  {
    name: 'Skapa konto',
    path: '/sign-up/',
  },
];

export const UnauthenticatedRoutes = () => {
  return (
    <>
      {unauthenticatedRoutes?.map((navItem) => (
        <NavigationItem key={navItem?.path || navItem?.name} path={navItem?.path} name={navItem?.name} />
      ))}
    </>
  );
};
